import { call, put, take, takeEvery, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { api } from 'services/api';
import {
	getHsCodesRequest,
	getHsCodesSuccess,
	getHsCodesFailure,
	getManualHsCodesRequest,
	getManualHsCodesSuccess,
	getManualHsCodesFailure,
} from './reducer';
import { IHsCodesRequest, IHsCodesResponse } from './types';
import { refreshTokenByTimeOutRequest, refreshTokenByTimeOutSuccess } from '../auth/reducer';

function* getHsCodesWorker(action: PayloadAction<IHsCodesRequest>) {
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: IHsCodesResponse = yield call(api.hscodes.getHsCodes, action.payload);
		yield put(getHsCodesSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			yield put(getHsCodesFailure(error.message));
		} else {
			yield put(getHsCodesFailure('Произошла ошибка при загрузке HS кодов'));
		}
	}
}

function* getManualHsCodesWorker(action: PayloadAction<number>) {
	try {
		yield put(refreshTokenByTimeOutRequest());
		yield take(refreshTokenByTimeOutSuccess.type);

		const response: IHsCodesResponse = yield call(api.hscodes.getHsCodesById, action.payload);
		yield put(getManualHsCodesSuccess(response));
	} catch (error) {
		if (axios.isAxiosError(error)) {
			yield put(getManualHsCodesFailure(error.message));
		} else {
			yield put(getManualHsCodesFailure('Произошла ошибка при загрузке HS кодов'));
		}
	}
}

function* hscodesWatcher() {
	yield takeLatest(getHsCodesRequest.type, getHsCodesWorker);
	yield takeLatest(getManualHsCodesRequest.type, getManualHsCodesWorker);
}

export { hscodesWatcher };
